import { faKey, faUser } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from 'components/base/Button';
import Input from 'components/common/form/input/Input';
import { Formik, Form } from 'formik';
import { Col, FormCheck, FormGroup, FormLabel, Row } from 'react-bootstrap';
import FormCheckInput from 'react-bootstrap/esm/FormCheckInput';
import FormCheckLabel from 'react-bootstrap/esm/FormCheckLabel';
import { Link, useNavigate } from 'react-router-dom';
import { useLoginMutation } from 'service/authQuery/authQuery';
import * as Yup from 'yup';
import { LoginPayload, LoginResponse } from './signInForm.type';
import { setLocalStorageObject } from 'helpers/localstorage-utils';
import { TOKEN_CONSTANTS } from '../../../constant';
import { UserType } from 'reducers/UserReducer';
import { useToast } from 'hooks/useToast';

const validationSchema = Yup.object({
  email: Yup.string().email().required('Email is required'),
  password: Yup.string().required('Password is required')
});

const SignInForm = () => {
  const [login, { isLoading }] = useLoginMutation();
  const navigate = useNavigate();
  const { open } = useToast();

  const navigatePathMap: { [key in UserType]: string } = {
    admin: '/center/dashboard',
    candidate: '/home/dashboard',
    institution: '/hub/dashboard',
    recruiter: '/panel/dashboard'
  };

  const handleSubmit = (payload: LoginPayload) => {
    login(payload)
      .unwrap()
      .then((response: LoginResponse) => {
        const auth = {
          [TOKEN_CONSTANTS.ACCESS]: response.token,
          [TOKEN_CONSTANTS.REFRESH]: response.refreshToken
        };
        setLocalStorageObject(auth);
        navigate(navigatePathMap[response.userType]);
      })
      .catch(err => open(err?.data?.error, 'error'));
  };
  return (
    <>
      <div className="text-center mb-7">
        <h3 className="text-body-highlight">Sign In</h3>
        <p className="text-body-tertiary">Get access to your account</p>
      </div>
      <div className="position-relative">
        <hr className="bg-body-secondary mt-5 mb-4" />
        <div className="divider-content-center">Sign in with email</div>
      </div>
      <Formik
        initialValues={{
          email: '',
          password: ''
        }}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        <Form>
          <FormGroup className="mb-3 text-start">
            <FormLabel htmlFor="email">Email address</FormLabel>
            <div className="form-icon-container">
              <Input
                name="email"
                id="email"
                type="email"
                className="form-icon-input"
                icon={
                  <FontAwesomeIcon
                    icon={faUser}
                    className="text-body fs-9 form-icon"
                  />
                }
              />
            </div>
          </FormGroup>
          <FormGroup className="mb-3 text-start">
            <FormLabel htmlFor="password">Password</FormLabel>
            <div className="form-icon-container">
              <Input
                name="password"
                id="password"
                type="password"
                className="form-icon-input"
                icon={
                  <FontAwesomeIcon
                    icon={faKey}
                    className="text-body fs-9 form-icon"
                  />
                }
              />
            </div>
          </FormGroup>
          <Row className="flex-between-center mb-7">
            <Col xs="auto">
              <FormCheck type="checkbox" className="mb-0">
                <FormCheckInput
                  type="checkbox"
                  name="remember-me"
                  id="remember-me"
                  defaultChecked
                />
                <FormCheckLabel htmlFor="remember-me" className="mb-0">
                  Remember me
                </FormCheckLabel>
              </FormCheck>
            </Col>
            <Col xs="auto">
              <Link to="/forgot-password" className="fs-9 fw-semibold">
                Forgot Password?
              </Link>
            </Col>
          </Row>
          <Button
            variant="primary"
            type="submit"
            className="w-100 mb-3"
            loading={isLoading}
            loadingPosition="start"
          >
            Sign In
          </Button>
        </Form>
      </Formik>
    </>
  );
};

export default SignInForm;
